import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import {
  AnswerSimulationArgs,
  AnswerSimulationPayload,
  answerSimulation
} from '@/modules/simulator/api'
import { toast } from 'react-toastify'
import { addError } from '@/global/plugins/observability'
import {
  Context,
  SimulatorCode
} from '@/global/plugins/observability/observability.constants'

type UseAnswerSimulationProps =
  | Partial<UseMutationOptions<void, Error, AnswerSimulationArgs, unknown>>
  | undefined

const useAnswerSimulation = ({ onSuccess }: UseAnswerSimulationProps = {}) => {
  const onError = (error: Error) => {
    toast('Ops! Tivemos um problema, tente novamente.')
    addError({
      error,
      data: {
        context: Context.SIMULATOR,
        code: SimulatorCode.ANSWER_SIMULATION_ERROR,
        message: 'Erro ao responder dados da empresa',
        location: 'useAnswerSimulation'
      }
    })
  }

  return useMutation({
    mutationFn: (data: { id: string; payload: AnswerSimulationPayload }) =>
      answerSimulation(data),
    onSuccess,
    onError
  })
}

export { useAnswerSimulation }
